import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export default function ThemeToggle() {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle-button"
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      data-testid="theme-toggle-button"
    >
      <div className="theme-toggle-icon">
        {isDark ? (
          <Sun className="w-5 h-5 text-[var(--accent-secondary)]" />
        ) : (
          <Moon className="w-5 h-5 text-[var(--accent-secondary)]" />
        )}
      </div>
      <span className="theme-toggle-label">
        {isDark ? 'Light' : 'Dark'}
      </span>
    </button>
  );
}
